import { Outlet } from 'react-router-dom'

import SplashScreen from 'layouts/splash'

function ProtectedRoute({ user }: { user: boolean }) {
	return user ? <Outlet /> : <SplashScreen />
}

function AuthRoute({ user }: { user: boolean }) {
	return !user ? <Outlet /> : <SplashScreen />
}

export { ProtectedRoute, AuthRoute }
